import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Router, hashHistory } from 'react-router'
import thunk from 'redux-thunk'
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux'
import routes from './routes'
import injectTapEventPlugin from 'react-tap-event-plugin'
import 'paho-mqtt/mqttws31.js'
import 'normalize.css'
import './index.css'
import Moment from 'moment'
import Push from 'push.js'

Moment.locale('pt-br')
Push.Permission.request()

import configureStore from './store/configureStore'

const store = configureStore([thunk, routerMiddleware(hashHistory)])

const history = syncHistoryWithStore(hashHistory, store)

injectTapEventPlugin()

ReactDOM.render(
  <Provider store={store}>
    <Router routes={routes} history={history} />
  </Provider>,
  document.getElementById('root')
)



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/